import React from "react";

// components
import SectionContainer from "core/SectionContainer";
import HeroLandingPage from "core/HeroLandingPage";
import OffsetGrid from "core/OffsetGrid";
import BulletSection from "core/BulletSection";
import Collections from "core/Collections";
import BlogPosts from "core/BlogPosts";
import PageMeta from "core/PageMeta";
import IconsSection from "marketing-pages/PricingMarketingPage/IconsSection";

// styles
import colors from "core/colors";
import { HeroSectionContainer } from "./styles";

// data
import {
    titleTag,
    metaDescription,
    heroImages,
    heroHeading,
    bullets,
    collectionsTitle,
    collections,
    pills,
    pillsTitle,
    iconHighlightTitle,
    iconHighlightsData
} from "./data";

const IconLandingPage = () => {
    return (
        <>
            <PageMeta
                title={titleTag}
                indexContent="index,follow,max-image-preview:large"
                description={metaDescription}
            />
            <HeroSectionContainer
                bgColor={colors.secondary.orca}
                textColor={colors.primary.diamond}
                topSpacing="none"
                bottomSpacing="4xl"
            >
                <OffsetGrid sm={10} md={12} lg={12}>
                    <HeroLandingPage
                        isIconLandingPage
                        heroImages={heroImages}
                        heading={heroHeading}
                        headingColor={colors.primary.diamond}
                        bgSizeTablet="55% auto"
                        bgPositionTablet="center right"
                        bgSizeDesktop="50% 90%"
                        bgPositionDesktop="650px 75px"
                    />
                </OffsetGrid>
            </HeroSectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <BulletSection bullets={bullets} />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer bgColor={colors.primary.diamond}>
                <Collections
                    title={collectionsTitle}
                    collections={collections}
                    pillsTitle={pillsTitle}
                    pills={pills}
                />
            </SectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <BlogPosts
                        posts={iconHighlightsData}
                        blogPostsTitle={iconHighlightTitle}
                    />
                </OffsetGrid>
            </SectionContainer>

            <IconsSection bgColor={colors.primary.diamond} />
        </>
    );
};

export default IconLandingPage;
